import React from 'react'
import { Form, Input, Button } from 'antd'
import { func } from 'prop-types'

import { useCreateOperator } from '@graphql/mutations'

function ManageOperatorForm({ afterSubmit }) {
  const [form] = Form.useForm()
  const [createOperator, { loading }] = useCreateOperator()

  const onFinish = data => {
    createOperator({
      variables: {
        data: { ...data },
      },
      refetchQueries: ['GetOperatorsQuery'],
    }).then(callback => afterSubmit(callback), form.resetFields())
  }

  return (
    <Form onFinish={onFinish} form={form}>
      <Form.Item
        name="name"
        rules={[
          {
            required: true,
            message: `Campo obrigatório`,
          },
        ]}
        hasFeedback
      >
        <Input placeholder="Nome do operador" size="large" autoFocus />
      </Form.Item>

      <Button
        type="primary"
        htmlType="submit"
        size="large"
        disabled={loading}
        block
      >
        Criar operador
      </Button>
    </Form>
  )
}

ManageOperatorForm.propTypes = {
  afterSubmit: func,
}

ManageOperatorForm.defaultProps = {
  afterSubmit: null,
}

export default ManageOperatorForm
